export default __webpack_public_path__ + "static/media/van.38ba01e6.png";